import React, { useState, useEffect, forwardRef } from 'react';
import './tableEmployees.css'
import moment from 'moment-timezone';
import 'moment/locale/es-us';
import { Table, Button, Flex } from 'antd';

import {
    EditOutlined,
    EyeOutlined
} from '@ant-design/icons';

const TableEmployees = forwardRef((props, ref) => {
    const [dataSource, setDataSource] = useState([])
    const [columns, setColumns] = useState([])

    useEffect(() => {
        // Configurar el idioma a 'es-us'
        moment.locale('es-us');
    }, []);

    const getFilters = (data, key) => {
        const uniqueValues = [...new Set(data.map(item => item[key]))];
        return uniqueValues.map(value => ({ text: value, value }));
    };

    useEffect(() => {
        let columns = [
            // {
            //     title: <div style={{ textAlign: "center" }}>ID</div>,
            //     dataIndex: 'empl_id',
            //     key: 'empl_id',
            // },
            {
                title: <div style={{ textAlign: "center" }}>Nombre Completo</div>,
                dataIndex: "empl_fullName",
                key: "empl_fullName",
                sorter: (a, b) => `${a.empl_first_name} ${a.empl_last_name}`.localeCompare(`${b.empl_first_name} ${b.empl_last_name}`),
                render: (text, row) => <span>{`${row.empl_first_name} ${row.empl_last_name}`}</span>,
            },
            {
                title: <div style={{ textAlign: "center" }}>Número de identificación</div>,
                dataIndex: "empl_dni",
                key: "empl_dni",
                sorter: (a, b) => a.empl_dni - b.empl_dni,
            },
            {
                title: <div style={{ textAlign: "center" }}>Email</div>,
                dataIndex: 'empl_email',
                key: 'empl_email',
            },
            {
                title: <div style={{ textAlign: "center" }}>Sede</div>,
                dataIndex: "empl_organization_hq_name",
                key: "empl_organization_hq_name",
                sorter: (a, b) => a.empl_organization_hq_name.localeCompare(b.empl_organization_hq_name),
                filters: getFilters(props.data, "empl_organization_hq_name"),
                onFilter: (value, record) => record.empl_organization_hq_name === value,
            },
            {
                title: <div style={{ textAlign: "center" }}>Gerencia</div>,
                dataIndex: "empl_management_area_name",
                key: "empl_management_area_name",
                sorter: (a, b) => a.empl_management_area_name.localeCompare(b.empl_management_area_name),
                filters: getFilters(props.data, "empl_management_area_name"),
                onFilter: (value, record) => record.empl_management_area_name === value,
            },
            {
                title: <div style={{ textAlign: "center" }}>Área</div>,
                dataIndex: "empl_area_name",
                key: "empl_area_name",
                sorter: (a, b) => a.empl_area_name.localeCompare(b.empl_area_name),
                filters: getFilters(props.data, "empl_area_name"),
                onFilter: (value, record) => record.empl_area_name === value,
            },
            {
                title: <div style={{ textAlign: "center" }}>Categoría del cargo</div>,
                dataIndex: "empl_job_category_name",
                key: "empl_job_category_name",
                sorter: (a, b) => a.empl_job_category_name.localeCompare(b.empl_job_category_name),
                filters: getFilters(props.data, "empl_job_category_name"),
                onFilter: (value, record) => record.empl_job_category_name === value,
            },
            {
                title: <div style={{ textAlign: "center" }}>Cargo</div>,
                dataIndex: "empl_job_title_name",
                key: "empl_job_title_name",
                sorter: (a, b) => a.empl_job_title_name.localeCompare(b.empl_job_title_name),
                filters: getFilters(props.data, "empl_job_title_name"),
                onFilter: (value, record) => record.empl_job_title_name === value,
            },
            {
                title: '',
                dataIndex: 'org_actions',
                key: 'org_actions',
                align: "center",
                fixed: "right",
                width: 60,
                render: (text, row, index) => {
                    return <Flex gap="small" wrap>
                        {/* <Button onClick={() => setOrganizationValuesToEdit(row)} type="primary" icon={<EditOutlined />} size={"large"} title='Editar organización' /> */}
                        <Button onClick={() => setEmployeesValuesToSee(row)} style={{ backgroundColor: "#293790", color: "white"}} icon={<EyeOutlined />} size={"large"} title='Ver información del colaborador' />
                    </Flex>
                }
            }
        ]

        setColumns(columns)

        let dataSource = props.data

        setDataSource(dataSource)

    }, [props.data])

    const setEmployeesValuesToSee = (org) => {
        props.setEmployeesValuesToSee(org)
    }

    return (
        <Table 
            className="custom-green-table"
            size={"small"} 
            dataSource={dataSource} 
            columns={columns} 
            pagination={{ pageSize: 10, position: ['bottomRight'] }} 
            scroll={{ x: 'max-content' }}
        />
    )
})

export default TableEmployees;